module.exports = __webpack_public_path__ + "static/media/48369067_2308757699199408_5113240634123091968_o-thumb.35a2b790.jpg";